import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

function VerifyId() {
  const { id } = useParams();

  const [idNumber, setIdNumber] = useState(id || "");
  const [user, setUser] = useState(null);
  const [result, setResult] = useState("");

  const verifyUser = async (customId) => {
    try {
      const response = await fetch("/api/verify-id", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_number: customId || idNumber,
        }),
      });

      const data = await response.json();

      if (data.status === "success") {
        setUser(data);

        setResult("verified");
      } else {
        setUser(null);

        setResult("invalid");
      }
    } catch (error) {
      setResult("error");
    }
  };

  useEffect(() => {
    if (id) {
      verifyUser(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    verifyUser();
  };

  return (
    <>
      <Header />

      <div
        style={{
          padding: "40px",
          textAlign: "center",
        }}
      >
        <h2>Verify ID</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter ID Number"
            value={idNumber}
            onChange={(e) =>
              setIdNumber(e.target.value)
            }
            required
            style={{
              padding: "10px",
              width: "250px",
            }}
          />

          <br />
          <br />

          <button
            type="submit"
            style={{
              padding: "10px 20px",
            }}
          >
            Verify
          </button>
        </form>

        <div style={{ marginTop: "30px" }}>
          {result === "verified" && (
            <div
              style={{
                border: "1px solid #ddd",
                padding: "20px",
                maxWidth: "400px",
                margin: "0 auto",
                borderRadius: "10px",
              }}
            >
              <h3 style={{ color: "green" }}>
                ✅ ID Verified
              </h3>

              <p>
                <strong>Name:</strong>{" "}
                {user.user_name}
              </p>

              <p>
                <strong>Designation:</strong>{" "}
                {user.designation}
              </p>

              <p>
                <strong>Mobile:</strong>{" "}
                {user.mobile}
              </p>

              <p>
                <strong>Email:</strong>{" "}
                {user.email}
              </p>

              <p>
                <strong>State:</strong>{" "}
                {user.state}
              </p>

              <p>
                <strong>City:</strong>{" "}
                {user.city}
              </p>

              <p>
                <strong>ID Number:</strong>{" "}
                {user.id_number}
              </p>
            </div>
          )}

          {result === "invalid" && (
            <h3 style={{ color: "red" }}>
              ❌ Invalid ID
            </h3>
          )}

          {result === "error" && (
            <h3 style={{ color: "orange" }}>
              ⚠️ Server Error
            </h3>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default VerifyId;